import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'transformHeure'
})
export class TransformHeurePipe implements PipeTransform {
    transform(heure: string): string {
        return heure?.substring(0, 5) ?? '';
    }
}
